// extracted by mini-css-extract-plugin
module.exports = {"entry":"Entry_entry__2YNDf","collapsedPlaceholder":"Entry_collapsedPlaceholder__MD04v"};